import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ToolsActivateService {
  private _undoRuleButton$ = new Subject<void>();
  private _redoRuleButton$ = new Subject<void>();
  private RulerActionObservable$ = new BehaviorSubject<boolean>(false);
  private RuleActionObservable$ = new BehaviorSubject<boolean>(false);
  private onShowCurveObservable$ = new BehaviorSubject<boolean>(false);
  private ZoomActionObservables$ = new BehaviorSubject<boolean>(false);
  private CurveMovementObservable$ = new BehaviorSubject<boolean>(false);
  private ScrollActionObservable$ = new BehaviorSubject<boolean>(false);
  private DrawerActionObservable$ = new BehaviorSubject<boolean>(false);
  private MoveBgActionObservable$ = new BehaviorSubject<boolean>(false);
  private CurrentTool$ = new BehaviorSubject<string>('');

  //This is used to declare true or false in the variable this.isNone
  setRulerAction(data: boolean) {
    this.RulerActionObservable$.next(data);
  }
  getRulerAction(): Observable<boolean> {
    return this.RulerActionObservable$.asObservable();
  }

  //this activate/deactivate the ruler button state
  getActivedRule(): Observable<boolean> {
    return this.RuleActionObservable$.asObservable();
  }
  // Lectura síncrona del estado de la Regla (espejo de getMoveBgValue). Útil para
  // decisiones puntuales de estilo/pan sin mantener una subscripción viva.
  getRuleValue(): boolean {
    return this.RuleActionObservable$.getValue();
  }
  setOnActivedRule(data: boolean) {
    this.RuleActionObservable$.next(data);
  }
  //this activate/deactivate the undo rule button state
  emitUndoRuleButton(): void {
    this._undoRuleButton$.next();
  }
  getUndoRuleButton() {
    return this._undoRuleButton$.asObservable();
  }
  emitRedoRuleButton(): void {
    this._redoRuleButton$.next();
  }
  getRedoRuleButton() {
    return this._redoRuleButton$.asObservable();
  }

  //this activate/deactivate the background movement button state
  getMoveBg(): Observable<boolean> {
    return this.MoveBgActionObservable$.asObservable();
  }
  // Lectura síncrona del flag. `getMoveBg()` devuelve un Observable que, si
  // se consume con `.subscribe()` dentro de una función imperativa, no
  // garantiza haberse resuelto antes de la siguiente línea (en realidad sí
  // para un BehaviorSubject, pero deja al caller mantener una subscripción
  // viva). Para chequeos puntuales este getter es más simple y seguro.
  getMoveBgValue(): boolean {
    return this.MoveBgActionObservable$.getValue();
  }
  setOnMoveBg(data: boolean) {
    this.MoveBgActionObservable$.next(data);
  }

  //this is the state of the curve. Is true when the curve is shown
  getShowCurve(): Observable<boolean> {
    return this.onShowCurveObservable$.asObservable();
  }
  setOnShowCurve(data: boolean) {
    this.onShowCurveObservable$.next(data);
  }

  //this activate/deactivate the curve movement button state
  getMovementCurve(): Observable<boolean> {
    return this.CurveMovementObservable$.asObservable();
  }

  setOnMovementCurve(data: boolean) {
    this.CurveMovementObservable$.next(data);
  }

  //this is the state of the drawer. Is true when imgs are loaded
  getActivedDrawer(): Observable<boolean> {
    return this.DrawerActionObservable$.asObservable();
  }
  setOnActivedDrawer(data: boolean) {
    this.DrawerActionObservable$.next(data);
  }

  //this activate/deactivate the zoom movement button state
  getActivedZoom(): Observable<boolean> {
    return this.ZoomActionObservables$.asObservable();
  }
  setOnActivedZoom(data: boolean) {
    this.ZoomActionObservables$.next(data);
  }

  //this activate/deactivate the scroll button state
  getActivedScroll(): Observable<boolean> {
    return this.ScrollActionObservable$.asObservable();
  }
  setOnActivedScroll(data: boolean) {
    this.ScrollActionObservable$.next(data);
  }

  //this is to display the class "active-button"
  getCurrentTool() {
    return this.CurrentTool$.asObservable();
  }
  setCurrentTool(toolName: string) {
    this.CurrentTool$.next(toolName);
  }

  toggleRuler() {
    const ruler = this.RuleActionObservable$.getValue();
    const newRuler = !ruler;
    this.setOnActivedRule(newRuler);
    if (newRuler) {
      this.setOnMoveBg(false);
      this.setOnActivedZoom(false);
      this.setOnActivedScroll(false);
      //The name is 'Draw to match with tool.originalKey
      this.setCurrentTool('Draw');
    } else {
      this.setCurrentTool('');
    }
  }

  toggleScroll() {
    const scroll = this.ScrollActionObservable$.getValue();
    const newScroll = !scroll;
    this.setOnActivedScroll(newScroll);
    if (newScroll) {
      this.setOnActivedRule(false);
      this.setOnActivedZoom(false);
      this.setOnMoveBg(false);
      this.setOnMovementCurve(true)
      //The name is 'Draw to match with tool.originalKey
      this.setCurrentTool('Scroll');
    } else {
      this.setCurrentTool('');
    }
  }

  toggleMoveBg() {
    const moveBg = this.MoveBgActionObservable$.getValue();
    const newMoveBg = !moveBg;
    this.setOnMoveBg(newMoveBg);
    if (newMoveBg) {
      this.setOnActivedRule(false);
      this.setOnActivedZoom(false);
      this.setOnActivedScroll(false);
      this.setOnMovementCurve(false);
      this.setCurrentTool('moveBg');
    } else {
      this.setCurrentTool('');
    }
  }


  toggleMoveCurve() {
    const movementCurve = this.CurveMovementObservable$.getValue();
    const newMovementCurve = !movementCurve;
    this.setOnMovementCurve(newMovementCurve);
    if (newMovementCurve === true) {
       this.setOnActivedRule(false);
      this.setOnActivedZoom(false);
      this.setOnActivedScroll(false);
      this.setOnMoveBg(false);
      this.setCurrentTool('movementCurve');
    } else {
      this.setCurrentTool('');
    }
  }
}
